class TryOn extends HTMLElement {
    constructor() {
        super();
        this.dialog = null;
        this.swiper = null;
        this.cards = null;
    }

    connectedCallback() {
        this.cards = this.querySelectorAll(".try-on-card");
        this.initSwipers();
        this.initDialog();
    }

    initDialog() {

        whenReady("markScrollable", () => {
            this.querySelectorAll(`[data-scroll-lock-scrollable]`).forEach($el => {
                markScrollable($el);
            })
        })

        whenReady("A11yDialog", () => {
            const modal = this.querySelector("#try-on-modal");
            if (!modal) return;
            
            this.dialog = new A11yDialog(modal);
    
            this.dialog.on("show", (event) => {
                const container = event.target;
                container.classList.add("active");
                document.addEventListener("keydown", this.handleEscapeKey.bind(this));

                const activeIndex = this.swiper.realIndex;
                const activeSlide = this.swiper.slides[activeIndex];
                this.swiperThumbs.slideTo(activeIndex);
                let mobileGalleryHeadHeight = Number(activeSlide.querySelector(".swiper-media-header .headline-32").clientHeight);
                this.querySelector(".swiper-arrows").style.setProperty('--offset-top', (mobileGalleryHeadHeight/2) - 16 + "px");
                if(activeSlide.querySelector("video") !== null){
                    const video = activeSlide.querySelector("video");
                    const playToggle = activeSlide.querySelector(".video-play");
                    if (video && !video.src) {
                        video.src = video.dataset.src; // Set src only when the slide becomes active
                        video.load();
                        setTimeout(() => {
                            this.swiper.updateAutoHeight(0);
                        }, 150);                    
                    }        
                    playToggle.onclick = (e) => {
                        e.preventDefault();
                        if (video.readyState >= 3) { // ReadyState 3 means it's loaded enough to play
                            video.play();
                            video.muted = false;
                            playToggle.classList.add("invisible");
                        }
                    }      
                }

                whenReady("disablePageScroll", () => {
                    disablePageScroll();
                })

            });
    
            this.dialog.on("hide", (event) => {
                const container = event.target;
                container.classList.remove("active");
                document.removeEventListener("keydown", this.handleEscapeKey.bind(this));

                whenReady("enablePageScroll", () => {
                    enablePageScroll();
                })

                if(this.querySelectorAll("video").length){
                    this.querySelectorAll("video").forEach($video => {
                        $video.muted = true;
                    })
                }
                
            });
        })
    }

    initSwipers() {
        whenReady("Swiper", () => {

            const galleryContainer = this.querySelector(".swiper-media");
            const contentContainer = this.querySelector(".swiper-content");
            const thumbsContainer = this.querySelector(".swiper-thumbs");
            const prevArrow = this.querySelector(".swiper-prev");
            const nextArrow = this.querySelector(".swiper-next");
            
            this.swiperThumbs = new Swiper(thumbsContainer, {
                a11y: true,
                loop: false, 
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
                allowTouchMove: true,
                spaceBetween: 20,
                mousewheel: {
                    forceToAxis: true
                }, 
                breakpoints: {
                    769: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        allowTouchMove: false                 
                    },
                    992: {
                        slidesPerView: 4,
                        allowTouchMove: false                 
                    }
                },
                modules: [Swiper.A11y, Swiper.Controller, Swiper.FreeMode, Swiper.Mousewheel]
            });
            
            this.swiper = new Swiper(galleryContainer, {
                a11y: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                autoHeight: true,
                thumbs: {
                    swiper: this.swiperThumbs // Let the gallery be controlled by thumbs
                },
                allowTouchMove: false,
                breakpoints: {
                    769: {
                        allowTouchMove: true                 
                    },
                    992: {
                        allowTouchMove: true                 
                    }
                },
                modules: [Swiper.A11y, Swiper.Controller, Swiper.Thumbs, Swiper.Navigation, Swiper.EffectFade]
            });
            
            this.swiperContent = new Swiper(contentContainer, {
                a11y: true,
                effect: 'fade',
                autoHeight: true,
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove: false,
                breakpoints: {
                    769: {
                        allowTouchMove: true                 
                    },
                    992: {
                        allowTouchMove: true                 
                    }
                },
                modules: [Swiper.A11y, Swiper.Controller, Swiper.EffectFade]
            });

            this.swiper.on("slideChange", () => {
                const activeIndex = this.swiper.realIndex;
                const activeSlide = this.swiper.slides[activeIndex];
                this.swiperThumbs.slideTo(activeIndex);
                let mobileGalleryHeadHeight = Number(activeSlide.querySelector(".swiper-media-header .headline-32").clientHeight);
                this.querySelector(".swiper-arrows").style.setProperty('--offset-top', (mobileGalleryHeadHeight/2) - 16 + "px");

                if(this.querySelector("video") !== null){
                    setTimeout(() => {                   
                        this.querySelectorAll(".video-play").forEach($play => {
                            $play.classList.remove("invisible")
                        })   
                        this.querySelectorAll("video").forEach($video => {
                            $video.muted = true;
                            $video.pause();
                            $video.currentTime = 0;
                        })
                    }, 150);
                }

                if(activeSlide.querySelector("video") !== null){
                    const video = activeSlide.querySelector("video");
                    const playToggle = activeSlide.querySelector(".video-play");
                    if (video && !video.src) {
                        video.src = video.dataset.src; // Set src only when the slide becomes active
                        video.load();
                        setTimeout(() => {
                            this.swiper.updateAutoHeight(0);
                        }, 150);
                    }                        
                    playToggle.onclick = (e) => {
                        e.preventDefault();
                        if (video.readyState >= 3) { // ReadyState 3 means it's loaded enough to play
                            video.play();
                            video.muted = false;
                            playToggle.classList.add("invisible");
                        }
                    }      
                }
            });

            thumbsContainer.querySelectorAll(".swiper-slide").forEach(($slide, i) => {
                $slide.addEventListener("click", e => {
                    e.preventDefault();
                    this.swiper.slideTo(i);
                })
            })

            if(this.cards.length){
                this.cards.forEach(($card, i) => {
                    $card.addEventListener("click", e => {
                        e.preventDefault();
                        this.swiper.slideTo(i);
                        this.dialog.show();
                    })
                })
            }
            
            this.swiper.controller.control = this.swiperContent;
            this.swiperContent.controller.control = this.swiper;
            
        });
    }

    handleEscapeKey(event) {
        if (event.key === "Escape" && this.dialog) {
            this.dialog.hide();
        }
    }
}

customElements.define("try-on", TryOn);